export default function Thumbnail({
  src,
  className = "h-full w-full object-cover "
}: {
  src: string;
  className?: string;
}) {
  return (
    <img
      src={src}
      alt="Card Image"
      className={className}
    />
  )
}